import { useId } from 'react';
import { cn } from '@shared/utils';
import styles from './checkbox.module.scss';

interface CheckboxProps {
  className?: string;
  title: string;
  checked: boolean;
  onChange: () => void;
}

export const Checkbox = (props: CheckboxProps) => {
  const id = useId();

  return (
    <div className={cn('relative', props.className)}>
      <input
        id={id}
        className={cn('m-0 h-[16px] w-[16px] align-top', styles.input)}
        type='checkbox'
        checked={props.checked}
        onChange={props.onChange}
      />
      <label htmlFor={id} className={cn('flex cursor-pointer items-center justify-start text-sm select-none', styles.label)}>
        <span
          className={cn(
            'relative mr-4 h-[28px] min-h-[28px] w-[28px] min-w-[28px] border border-[#ffffff66] transition-colors duration-200',
            styles.box,
          )}
        >
          <span className={cn('hidden h-full', styles.check)}>
            <svg
              className={cn('absolute top-[-18px] left-[-10px] h-[54px] w-[54px]', styles.icon)}
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 52 52'
            >
              <path className={styles.path} d='M14.1 27.2l7.1 7.2 16.7-16.8' />
            </svg>
          </span>
        </span>
        <span className='title text-[#ffffff66] transition-colors duration-200'>{props.title}</span>
      </label>
    </div>
  );
};
